<div class="row ss-top-menu">
  <div class="col-xl-8 col-lg-8 col-md-8 col-sm-8 col-xs-8">
    <span class="ss-text-light">User Mapping <i class="rightArrow fa fa-angle-right"></i></span>
      <span class="ss-text-dark">Upload</span>
    </div>
</div>

<div class="rk-ui-notification err" *ngIf="erroralert"  style="z-index: 10000;">
  <span id="notificationMessageText">{{errorMessage}}</span>
  <a class="close rk-linknotification" (click)="erroralert=false">×</a>
</div>
<div class="rk-ui-notification" *ngIf="successalert"  style="z-index: 10000;">
  <span id="notificationMessageText">{{successMessage}}</span>
  <a class="close rk-linknotification" (click)="successalert=false">×</a>
</div>

<div class="row">
  <div class="col-md-12 mt-2" style="background-color: #fff; padding-top:10rem; padding-bottom:10rem;">
    <div class="row justify-content-center">
      <div class="col-sm-4 card-upload">
        <div class="row">
          <div class="col-sm-12">
            <input id="file" type="file" class="inputfile" name="" value="Upload Excel" (change)="uploadFile($event)" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" >
            <label for="file">Browse File</label>
          </div>
          <div class="col-sm-12">
            <div class="row pt-2 pb-2 mt-4 file-col">
              <div class="col-sm-9">
                <div class="col-sm-12">
                  <div id="fileName"></div>
                </div>
                <div class="col-sm-12">
                  <span id="fileSize"></span>
                </div>
              </div>
              <div class="col-sm-3 text-center">
                <i class="fa fa-cloud-upload mt-2" (click) = "submit()"></i>
                <!-- <i class="fa fa-hourglass-half mt-2"></i> -->
                <span class = "wait-load">
                  <div class="lds-css ng-scope">
                    <div class="lds-spinner" style="100%;height:100%">
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                    </div>
                  </div>
                </span>
                <i class="fa fa-check-circle mt-2"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
  </div>
</div>


// WEBPACK FOOTER //
// /Users/shobhit/Documents/codes/arrivae-frontend/src/app/platform/organisation/user-mapping/upload/upload.component.html